const defaultState = {
  loggedIn: false,
  loggingIn: false,
  error: null,
  expires_at: null,
  user: null
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "OTHER_USER_FETCH_LOGIN": {
        return {
          ...state,
          loggingIn: true
        }
      }
      case "OTHER_USER_FETCH_LOGIN_REJECTED": {
        return {
          ...state,
          loggedIn: false,
          error: action.payload,
          loggingIn: false
        }
      }
      case "OTHER_USER_FETCH_LOGIN_FULFILLED": {
        return {
          ...state,
          loggedIn: true,
          user: action.payload.user,
          expires_at: action.payload.expires_at,
          loggingIn: false,
        }
      }
      case "OTHER_USER_LOGGED_IN": {
        return {
          ...state,
          loggedIn: true,
          user: action.payload.user,
          expires_at: action.payload.expires_at,
          loggingIn: false
        }
      }
      case "OTHER_USER_LOGOUT":{
        return{
          ...state,
          loggedIn: false,
          user: null,
          loggingIn: false,
          error: null
        }
      }
      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/otherUserReducer.js